/**
 * Voxly — Ambient backing beds for voice recordings.
 *
 * Each bed maps to a curated iTunes search query so users can pick a "mood"
 * (Rain, Thunder, Spring Birds, Calm, Happy, Sad, Warm, Lofi Beats) without
 * having to type into the search box. The MusicPicker's existing iTunes
 * integration returns 30-second previews which is perfect for voice clips.
 *
 * Why iTunes instead of synthesized sounds:
 *  - Real recordings sound dramatically better than Web Audio synthesis
 *  - No asset hosting / bandwidth costs
 *  - Already wired up via /api/music endpoints
 */

export const AMBIENT_BEDS = [
  // Nature
  { id: "rain",      label: "Rain",          emoji: "🌧",  query: "gentle rain sounds" },
  { id: "thunder",   label: "Thunder",       emoji: "⛈",  query: "thunderstorm rain ambient" },
  { id: "ocean",     label: "Ocean waves",   emoji: "🌊", query: "ocean waves relaxing" },
  { id: "fireplace", label: "Fireplace",     emoji: "🔥", query: "crackling fireplace" },
  { id: "birds",     label: "Spring birds",  emoji: "🐦", query: "morning birds forest" },
  { id: "wind",      label: "Wind",          emoji: "🍃", query: "soft wind ambient" },
  // Moods
  { id: "calm",      label: "Calm",          emoji: "🧘", query: "calm piano meditation" },
  { id: "happy",     label: "Happy",         emoji: "😊", query: "happy ukulele acoustic" },
  { id: "sad",       label: "Sad",           emoji: "🥲", query: "sad piano emotional" },
  { id: "warm",      label: "Warm",          emoji: "☕", query: "warm acoustic guitar" },
  { id: "lofi",      label: "Lo-Fi beats",   emoji: "🎧", query: "lofi beats chill" },
  { id: "cinematic", label: "Cinematic",     emoji: "🎬", query: "cinematic ambient epic" },
];
